import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 30 30"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#3C492F",
  d: "M13 21.001a1.998 1.998 0 0 1 2.765-1.846A2 2 0 0 1 17 21a2 2 0 0 1-2 2 2 2 0 0 1-2-1.999M13.196 9a1.809 1.809 0 1 1 3.6 0l-.7 7.01a1.105 1.105 0 0 1-2.2 0z"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }